import { createFetcher } from "api/helpers"

const fetcherConfiguration = {
  method: "get",
  makeRequestUrl: (host, params) => {
    return `${host}/cp/get_cms_canned_report${params}`
  },
  checkRequiredArguments: () => {},
  makeResponseData: (json) => {
    return json
  }
}
export default createFetcher(fetcherConfiguration)
